"use client";
import classNames from "classnames";
import styles from "./styles.module.scss";
import { use, useEffect, useState } from "react";
import { getProductBySku } from "@/lib/bba/product/getProductBySku";
import { generateVehiclesArray } from "@/utils/common";
import Image from "next/image";
import IconMinus from "@/components/Icon/IconMinus.svg";
import IconPlus from "@/components/Icon/IconPlus.svg";
import Link from "next/link";

export default function Fitment({ product, bbaProductPromise }) {
  const bbaProduct = use(bbaProductPromise);
  const vehicles = bbaProduct.vehicles || [];
  const accordionData = generateVehiclesArray(vehicles, "year", "make");

  useEffect(() => {
    if (!document.getElementById("fitmentTab")) return;
    if (vehicles.length > 0) {
      document.getElementById("fitmentTab").style.display = "block";
    } else {
      document.getElementById("fitment").style.display = "none";
    }
  }, []);

  return (
    vehicles &&
    vehicles.length > 0 && (
      <div
        className={classNames(
          "h-full overflow-y-auto border-[1px] border-grey rounded px-10 py-5 font-roboto",
          styles.bikeFitmentScrollBar
        )}
      >
        <p className="font-bold text-lg leading-8">Check your bike fitment</p>
        {Object.keys(accordionData)
          .sort((a, b) => a.localeCompare(b))
          .map((year, i) => (
            <div key={`make-${i}`} className={classNames("bikebiz-accordion", styles.accordions)}>
              <details className={classNames("w-full ", styles.makeDetails)}>
                <summary
                  className={classNames(
                    "h-[48px] flex items-center text-lg font-bold border-b-[1px]",
                    styles.makeSumary
                  )}
                >
                  {year}
                </summary>
                <div className="w-full">
                  {accordionData[year].map((yearItem, j) =>
                    Object.keys(yearItem).map((make, k) => (
                      <div key={`year-${j}`} className={classNames("bikebiz-accordion")}>
                        <details className={classNames("w-full", styles.yearDetails)}>
                          <summary
                            className={classNames(
                              "h-[48px] flex items-center text-bas font-bold capitalize relative border-b-[1px] border-grey-200"
                            )}
                          >
                            {make}
                            <div className="absolute right-0 top-1/2 -translate-y-1/2 ">
                              <Image
                                src={IconMinus.src}
                                width={11}
                                height={1}
                                alt="IconMinus"
                                className={styles["icon-collapse"]}
                              />
                              <Image
                                src={IconPlus.src}
                                width={11}
                                height={11}
                                alt="IconPlus"
                                className={styles["icon-expand"]}
                              />
                            </div>
                          </summary>
                          <div>
                            {yearItem[make]
                              .sort((a, b) => a.model.localeCompare(b.model))
                              .map((vehicle, h) => (
                                <Link key={`model-${h}`} href={`/vehicles/${vehicle.slug}`}>
                                  <div className="text-sm leading-[26px] uppercase">{vehicle.model}</div>
                                </Link>
                              ))}
                          </div>
                        </details>
                      </div>
                    ))
                  )}
                </div>
              </details>
            </div>
          ))}
      </div>
    )
  );
}
